import { IfPermission } from '@app/core/auth/authorization/components/IfPermission';
import { PublishToggleCard } from '../social-export/PublishToggleCard';
import { fragmentsPermissions } from '@app/modules/fragments/fragments-permissions';
import IosShareIcon from '@mui/icons-material/IosShare';
import { FormattedMessage } from 'react-intl';

/** Toggle for enabling external export when creating a fragment. */
export function ExportControl() {
  return (
    <IfPermission permission={fragmentsPermissions.Fragments_Delivery}>
      <PublishToggleCard
        icon={<IosShareIcon fontSize="small" color="action" />}
        label={
          <FormattedMessage
            id="jointFragments.form.externalExport.allowedLabel"
            defaultMessage="Export externo"
          />
        }
        switchName="doExternalExport"
      />
    </IfPermission>
  );
}
